<script setup>
import WorkflowRuleForm from './WorkflowRuleForm.vue';

const props = defineProps({
  conditions: {
    type: Object,
    required: true,
  },
  getConditionDropdownValues: {
    type: Function,
    required: true,
  },
  appendNewCondition: {
    type: Function,
    required: true,
  },
  removeFilter: {
    type: Function,
    required: true,
  },
});
</script>

<template>
  <WorkflowRuleForm
    :conditions="props.conditions"
    :get-condition-dropdown-values="getConditionDropdownValues"
    :append-new-condition="appendNewCondition"
    :remove-filter="removeFilter"
  />
</template>
